import GuardedRoute from './GuardedRoute';

export default GuardedRoute;
